
import { useState } from "react";
import { Requirement, Guidance } from "@/types/project";
import { fetchGuidanceForRequirement } from "@/integrations/supabase/client";
import GuidanceDrawer from "@/components/GuidanceDrawer";
import { toast } from "sonner";

interface RequirementGuidanceProps {
  projectId: string;
}

export function RequirementGuidance({ projectId }: RequirementGuidanceProps) {
  const [guidance, setGuidance] = useState<Guidance | null>(null);
  const [isGuidanceLoading, setIsGuidanceLoading] = useState(false);
  const [isGuidanceOpen, setIsGuidanceOpen] = useState(false);
  const [requirementText, setRequirementText] = useState("");

  const handleViewGuidance = async (requirement: Requirement) => {
    try {
      setIsGuidanceLoading(true);
      setIsGuidanceOpen(true);
      
      const guidanceData = await fetchGuidanceForRequirement(requirement.id);
      
      if (guidanceData) {
        setGuidance(guidanceData);
        setRequirementText(requirement.requirement_text || requirement.text || "");
      } else {
        setGuidance(null);
        toast.warning("No guidance available for this requirement");
      }
    } catch (error) {
      console.error("Error fetching guidance:", error);
      toast.error("Failed to fetch guidance information");
    } finally {
      setIsGuidanceLoading(false);
    }
  };

  return {
    guidance,
    isGuidanceLoading,
    isGuidanceOpen,
    setIsGuidanceOpen,
    requirementText,
    handleViewGuidance,
    GuidanceDrawerComponent: (
      <GuidanceDrawer 
        open={isGuidanceOpen} 
        onOpenChange={setIsGuidanceOpen} 
        guidance={guidance}
        requirementText={requirementText}
      />
    )
  };
}
